module.exports = __webpack_public_path__ + "img/haiyi.3af8a2f4.jpg";